var twentysixtee = (function () {
  var yearData = {
    "1948": {
      title: "California",
      image: window.themeAssets.california,
      description:
        "A beachside bluff with rolling ocean waves and palm trees sets the scene, alongside the original “No Delay” sign and the Los Angeles skyline, paying homage.",
      longDescription:
        "A beachside bluff with rolling ocean waves and palm trees sets the scene, alongside the original “No Delay” sign and the Los Angeles skyline, paying homage to <span style=\"white-space: nowrap\">In-N-Out’s</span> roots in Baldwin Park, California, where it all began in 1948. In a humble 10’ x 10’ space, Harry Snyder introduces California’s first drive-thru hamburger stand. Each morning before dawn, he hand-selects fresh meat and produce from local markets, while his wife, Esther, manages the accounting from their nearby home. At night, he works in his garage, perfecting his vision of enabling guests to order and receive meals without having to leave their cars. His innovative two-way speaker box makes true drive-thru service possible, setting the foundation for everything to come.",
      desktop: {
        card: { top: 15, left: 1, width: 60 },
        magnifierSize: { width: 22, height: 40 },
        focus: { x: 3, y: 30 },
        zoom: 6.5,
        layout: "right"
      },
      mobile: {
        card: { top: 15, left: 1, width: 70 },
        magnifierSize: { width: 30, height: 50 },
        focus: { x: 3, y: 30 },
        zoom: 6.5,
        layout: "right"
      }
    },
    "1992": {
      title: "Nevada",
      image: window.themeAssets.nevada,
      description:
        "Next stop, Nevada! This artwork depicts the hazy blend between where the desert meets the vibrant lights of the Las Vegas skyline.",
      longDescription:
        "Next stop, Nevada! This artwork depicts the hazy blend between where the desert meets the vibrant lights of the Las Vegas skyline. Illuminating the company’s presence in Nevada is the classic neon <span style=\"white-space: nowrap\">In-N-Out</span> sign, the largest restaurant sign in Nevada, which shines prominently along the skyline.\n\n<span style=\"white-space: nowrap\">In-N-Out’s</span> 80th restaurant opens in Las Vegas, Nevada, in 1992, at 2900 W. Sahara Boulevard. An Elvis impersonator floats down by parachute to the song, “Viva Las Vegas,” and Rich Snyder drives down the Las Vegas Strip, quoting Benjamin Franklin: “The handshake of the host determines the taste of the roast.”",
      desktop: {
        card: { top: 8, left: 15, width: 37 },
        magnifierSize: { width: 37, height: 35 },
        focus: { x: 27, y: 18 },
        zoom: 4.2,
        layout: "bottom"
      },
      mobile: {
        card: { top: 8, left: 15, width: 55 },
        magnifierSize: { width: 55, height: 40 },
        focus: { x: 27, y: 18 },
        zoom: 4.2,
        layout: "bottom"
      }
    },
    "2000": {
      title: "Arizona",
      image: window.themeAssets.arizona,
      description: "Arizona’s iconic red rock formations are set amidst winding desert roads and iconic Route 66 signage. A classic 1987 Chevrolet K30 truck drives along the road.",
      longDescription: "Arizona’s iconic red rock formations are set amidst winding desert roads and iconic Route 66 signage. A classic 1987 Chevrolet K30 truck drives along the road, with Guy Snyder at the wheel and his daughter, Lynsi Snyder, riding shotgun, the license plate displaying his birth year. <span style=\"white-space: nowrap\">In-N-Out’s</span> first restaurant in Arizona opens in Lake Havasu City in 2000, at 81-101 London Bridge Road. Associates working at the prep sink can glance out the window and see the historic London Bridge, making this location truly one of a kind.",
      desktop: {
        card: { top: 30, left: 13, width: 35 },
        magnifierSize: { width: 35, height: 20 },
        focus: { x: 26, y: 40 },
        zoom: 4,
        layout: "bottom"
      },
      mobile: {
        card: { top: 20, left: 9, width: 50 },
        magnifierSize: { width: 50, height: 20 },
        focus: { x: 26, y: 40 },
        zoom: 4,
        layout: "bottom"
      }
    },
    "2008": {
      title: "Utah",
      image: window.themeAssets.utah,
      description: "Behind the Vegas skyline, Utah’s iconic Monument Valley plateaus rise, showcasing the region’s breathtaking desert landscapes.",
      longDescription: "Behind the Vegas skyline, Utah’s iconic Monument Valley plateaus rise, showcasing the region’s breathtaking desert landscapes. <span style=\"white-space: nowrap\">In-N-Out</span> proudly opens its doors in Southern Utah in 2008, marking a milestone as the company's 215th location. Originally called “Saint George,” <span style=\"white-space: nowrap\">In-N-Out</span> quickly learns how proud locals are of their community, so the name changes to Washington City. The mayor and city officials join a ribbon-cutting ceremony on opening day, and residents give a warm welcome to Southern Utah.",
      desktop: {
        card: { top: 30, left: 9, width: 35 },
        magnifierSize: { width: 35, height: 18 },
        focus: { x: 21, y: 35 },
        zoom: 4.2,
        layout: "bottom"
      },
      mobile: {
        card: { top: 20, left: 2, width: 50 },
        magnifierSize: { width: 50, height: 18 },
        focus: { x: 21, y: 34 },
        zoom: 4.2,
        layout: "bottom"
      }
    },
    "2011": {
      title: "Texas",
      image: window.themeAssets.texas,
      description: "Texas’s flat plains represent the largest state where <span style=\"white-space: nowrap\">In-N-Out</span> is served.",
      longDescription: "Texas’s flat plains represent the largest state where <span style=\"white-space: nowrap\">In-N-Out</span> is served. A humble farm stands as a tribute to fresh ingredients and homegrown values. Founders, Harry and Esther Snyder, ride in a white 1957 Chevrolet Bel Air, its license plate reading “1948,” the year <span style=\"white-space: nowrap\">In-N-Out</span> opened.\n\nTexans have double the reason to celebrate as the first two restaurants open simultaneously in Allen and Frisco on May 11th, 2011. Meanwhile, a new warehouse and patty-making facility opens about 30 miles away in Dallas, ensuring the same quality and freshness as the original Baldwin Park location for these restaurants and many more to come.",
      desktop: {
        card: { top: 35, left: 40, width: 50 },
        magnifierSize: { width: 50, height: 25 },
        focus: { x: 80, y: 50 },
        zoom: 3,
        layout: "bottom"
      },
      mobile: {
        card: { top: 30, left: 40, width: 50 },
        magnifierSize: { width: 50, height: 25 },
        focus: { x: 80, y: 50 },
        zoom: 3,
        layout: "bottom"
      }
    },
    "2015": {
      title: "Oregon",
      image: window.themeAssets.oregon,
      description: "The Mt. Hood anchors the Oregon design, framed by rugged White River rocks, and features a fox, a tribute to Lynsi Snyder’s nickname given by her father.",
      longDescription: "The Mt. Hood anchors the Oregon design, framed by rugged White River rocks, and features a fox, a tribute to Lynsi Snyder’s nickname given by her father. In 2015, <span style=\"white-space: nowrap\">In-N-Out</span> opens its first Oregon location in Medford, marking its sixth state and celebrating the occasion on Harry Snyder’s birthday, September 9th. The excitement is unforgettable: a line of cars wrapped around the parking lot, and the first Customers – a father and his daughter – camped out overnight alongside other loyal fans to be part of <span style=\"white-space: nowrap\">In-N-Out</span> history.",
      desktop: {
        card: { top: 25, left: 40, width: 42 },
        magnifierSize: { width: 42, height: 25 },
        focus: { x: 62, y: 33 },
        zoom: 4,
        layout: "bottom"
      },
      mobile: {
        card: { top: 19, left: 30, width: 55 },
        magnifierSize: { width: 55, height: 25 },
        focus: { x: 62, y: 33 },
        zoom: 4,
        layout: "bottom"
      }
    },
    "2020": {
      title: "Colorado",
      image: window.themeAssets.colorado,
      description: "Colorado's natural beauty is reflected in the majestic Rocky Mountains that stretch across this segment.",
      longDescription: "Colorado's natural beauty is reflected in the majestic Rocky Mountains that stretch across this segment. <span style=\"white-space: nowrap\">In-N-Out’s</span> first two restaurants open on the same day in Colorado Springs and Aurora in 2020. During opening day, a merchandise tent is set up in the parking lot of each store, and Customers are able to shop for special <span style=\"white-space: nowrap\">In-N-Out</span> merchandise while artist Carl Bork signs the commemorative 2020 Colorado T-shirt on-site.",
      desktop: {
        card: { top: 20, left: 50, width: 45 },
        magnifierSize: { width: 45, height: 25 },
        focus: { x: 80, y: 25 },
        zoom: 4,
        layout: "bottom"
      },
      mobile: {
        card: { top: 12, left: 48, width: 45 },
        magnifierSize: { width: 45, height: 25 },
        focus: { x: 80, y: 25 },
        zoom: 4,
        layout: "bottom"
      }
    },
    "2023": {
      title: "Idaho",
      image: window.themeAssets.idaho,
      description: "The wide Texas plains transition into Idaho’s rugged landscape, where the iconic Perrine Bridge stretches across the scene.",
      longDescription: "The wide Texas plains transition into Idaho’s rugged landscape, where the iconic Perrine Bridge stretches across the scene. A purple-blue 1936 Ford Willy Coupe cruises over the bridge, marking a journey toward a major milestone. In 2023, <span style=\"white-space: nowrap\">In-N-Out</span> Burger’s 400th location opens in Meridian, Idaho – its first in the state and a proud addition during the 75th anniversary year. Dedicated to the company’s most important asset – the Customer – this location reflects a legacy carried on by an <span style=\"white-space: nowrap\">In-N-Out</span> Family of more than 42,000 Associates who continue to serve every burger with a signature smile and the timeless values set by Founders, Harry and Esther Snyder.",
      desktop: {
        card: { top: 35, left: 50, width: 45 },
        magnifierSize: { width: 45, height: 18 },
        focus: { x: 100, y: 45 },
        zoom: 4,
        layout: "bottom"
      },
      mobile: {
        card: { top: 28, left: 50, width: 45 },
        magnifierSize: { width: 45, height: 18 },
        focus: { x: 100, y: 45 },
        zoom: 4,
        layout: "bottom"
      }
    },
    "2025": {
      title: "Washington",
      image: window.themeAssets.washington,
      description: "Set against the backdrop of Snoqualmie Falls, the design captures the essence of the Pacific Northwest’s natural beauty.",
      longDescription: "Set against the backdrop of Snoqualmie Falls, the design captures the essence of the Pacific Northwest’s natural beauty.  On August 20, 2025, <span style=\"white-space: nowrap\">In-N-Out</span> opens its first Washington location in Ridgefield, marking its ninth state and completing its presence along the West Coast. Fun fact: Long before Harry and Esther Snyder opened the original <span style=\"white-space: nowrap\">In-N-Out</span> Burger in Baldwin Park, CA, their story began in Washington, where they were living and eventually met.",
      desktop: {
        card: { top: 32, left: 68, width: 25 },
        magnifierSize: { width: 25, height: 15 },
        focus: { x: 90, y: 37 },
        zoom: 5.5,
        layout: "bottom"
      },
      mobile: {
        card: { top: 26, left: 50, width: 45 },
        magnifierSize: { width: 45, height: 15 },
        focus: { x: 90, y: 37 },
        zoom: 5.5,
        layout: "bottom"
      }
    },
    "2026": {
      title: "Tennessee",
      image: window.themeAssets.tennessee,
      description: "The Great Smoky Mountains dominate the scene, honoring Tennessee’s rich musical heritage and cultural richness.",
      longDescription: "The Great Smoky Mountains dominate the scene, honoring Tennessee’s rich musical heritage and cultural richness. At the base of these peaks, the city lights of Franklin shimmer in the distance, symbolizing <span style=\"white-space: nowrap\">In-N-Out’s</span> continued growth and a bright nod to welcome Tennessee as its 10th state. ",
      desktop: {
        card: { top: 29, left: 74, width: 25 },
        magnifierSize: { width: 25, height: 15 },
        focus: { x: 99, y: 35 },
        zoom: 7,
        layout: "bottom"
      },
      mobile: {
        card: { top: 29, left: 54, width: 45 },
        magnifierSize: { width: 45, height: 15 },
        focus: { x: 99, y: 35 },
        zoom: 7,
        layout: "bottom"
      }
    }
  };

  var root = document.getElementById("twentysix-tee-wrapper");
  if (!root) return;

  var sceneWrapper = root.querySelector(".twentysix-tee-scene-wrapper");
  var sceneImage = root.querySelector(".twentysix-tee-scene-image");
  var card = root.querySelector(".twentysix-tee-card");
  var magnifier = root.querySelector(".twentysix-tee-magnifier");
  var cardTitle = root.querySelector(".twentysix-tee-card-title");
  var cardText = root.querySelector(".twentysix-tee-card-text");
  var cardTextMobile = root.querySelector(".twentysix-tee-card-text-mobile span");
  var yearButtons = Array.prototype.slice.call(
    root.querySelectorAll(".twentysix-tee-year")
  );

  var closeBtn = root.querySelector("#twentysix-tee-close-button");
  var sheet = root.querySelector(".twentysix-tee-modal");
  var modalTitle = root.querySelector(".twentysix-tee-modal-title");
  var modalText = root.querySelector(".twentysix-tee-modal-text");
  var modalClose = root.querySelector(".twentysix-tee-modal-close");
  var modalImage = root.querySelector(".twentysix-tee-modal-image");
  var yearList = root.querySelector(".twentysix-tee-year-list");

  var activeYear = null;
  var isAnimating = false;
  var scrollTimer = null;
  var scrolled = false;

  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function setCardLayout(layout) {
    card.classList.remove("twentysix-tee-card-layout-right", "twentysix-tee-card-layout-bottom");
    if (layout === "bottom") {
      card.classList.add("twentysix-tee-card-layout-bottom");
    } else {
      card.classList.add("twentysix-tee-card-layout-right");
    }
  }

  function applyCardGeometry(config) {
    card.style.top = config.card.top + "%";
    card.style.left = config.card.left + "%";
    card.style.width = config.card.width + "%";
    card.style.height = "auto";
  }

  function setActiveYear(yearKey) {
    var data = yearData[yearKey];
    if (!data || yearKey === activeYear) return;

    var modeConfig = isMobile() ? data.mobile : data.desktop;

    activeYear = yearKey;
    root.classList.add("twentysix-tee-has-selection");

    yearButtons.forEach(function (btn) {
      btn.classList.toggle("active", btn.getAttribute("data-year") === yearKey);
    });

    card.classList.remove("twentysix-tee-card-content-visible");
    isAnimating = true;

    setCardLayout(modeConfig.layout);
    applyCardGeometry(modeConfig);

    cardTitle.textContent = data.title || "";
    cardText.innerHTML = data.longDescription || "";
    cardTextMobile.innerHTML = data.description || "";
    modalTitle.textContent = data.title || "";
    modalText.innerHTML = data.longDescription || data.description || "";
    modalImage.src = data.image || "";

    updateMagnifierSize(modeConfig);
    updateMagnifierBackground(modeConfig);
    showless();
  }

  closeBtn.addEventListener("click", function () {
    activeYear = null;
    root.classList.remove("twentysix-tee-has-selection");
    yearButtons.forEach(function (btn) {
      btn.classList.remove("active");
    });
    card.classList.remove("twentysix-tee-card-content-visible");
  });

  card.addEventListener("transitionend", function (evt) {
    if (
      evt.propertyName === "top" ||
      evt.propertyName === "left" ||
      evt.propertyName === "width" ||
      evt.propertyName === "height"
    ) {
      if (!isAnimating) return;
      isAnimating = false;
      card.classList.add("twentysix-tee-card-content-visible");
    }
  });

  yearButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var year = btn.getAttribute("data-year");
      setActiveYear(year);
      if (isMobile() && (scrolled || (year !== "1948" && year !== "1992"))) {
        centerYearInTimeline(year);
      }
    });
  });

  function centerYearInTimeline(yearKey) {
    if (!yearList) return;
    var containerRect = yearList.getBoundingClientRect();
    var centerX = containerRect.left + containerRect.width / 2;
    var targetBtn = yearButtons.find(function (btn) {
      return btn.getAttribute("data-year") === yearKey;
    });

    if (!targetBtn) return;
    var btnRect = targetBtn.getBoundingClientRect();
    var btnCenter = btnRect.left + btnRect.width / 2;
    var delta = btnCenter - centerX;

    yearList.scrollTo({
      left: yearList.scrollLeft + delta,
      behavior: "smooth"
    });
  }

  function snapToClosestYear() {
    if (!isMobile()) return;
    var containerRect = yearList.getBoundingClientRect();
    var centerX = containerRect.left + containerRect.width / 2;
    var closestBtn = null;
    var closestDist = Infinity;

    yearButtons.forEach(function (btn) {
      var rect = btn.getBoundingClientRect();
      var btnCenter = rect.left + rect.width / 2;
      var dist = Math.abs(btnCenter - centerX);
      if (dist < closestDist) {
        closestDist = dist;
        closestBtn = btn;
      }
    });

    if (closestBtn) {
      var yearKey = closestBtn.getAttribute("data-year");
      centerYearInTimeline(yearKey);
      setActiveYear(yearKey);
    }

    if (scrolled === false) {
      scrolled = true;
    }
  }

  function updateMagnifierSize(config) {
    var sceneRect = sceneWrapper.getBoundingClientRect();
    var sizeCfg = config.magnifierSize || { width: 25, height: 30 };

    var wPx = (sceneRect.width * (sizeCfg.width / 100)) || 260;
    var hPx = (sceneRect.height * (sizeCfg.height / 100)) || 260;

    magnifier.style.width = config.layout === "right" ? wPx + "px" : 'auto';
    magnifier.style.height = hPx + "px";
  }

  function updateMagnifierBackground(config) {
    var zoom = config.zoom || 1.6;
    magnifier.style.backgroundSize = zoom * 100 + "% auto";
    magnifier.style.backgroundPosition = config.focus.x + "% " + config.focus.y + "%";
  }

  function showmore() {
    if (!activeYear) return;
    sheet.classList.add("is-open");
  }

  function showless() {
    sheet.classList.remove("is-open");
  }

  function onYearListScroll() {
    if (!isMobile()) return;
    if (scrollTimer) window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(snapToClosestYear, 80);
  }

  yearList.addEventListener("scroll", onYearListScroll);

  if (modalClose) {
    modalClose.addEventListener("click", function (e) {
      e.stopPropagation();
      sheet.classList.remove("is-open");
    });
  }
  sheet.addEventListener("click", function (e) {
    if (e.target === sheet) {
      sheet.classList.remove("is-open");
    }
  });

  window.addEventListener("resize", function () {
    if (!activeYear) return;
    var data = yearData[activeYear];
    if (!data) return;
    var cfg = isMobile() ? data.mobile : data.desktop;
    setCardLayout(cfg.layout);
    applyCardGeometry(cfg);
    updateMagnifierSize(cfg);
    updateMagnifierBackground(cfg);
  });

  if (sceneImage && !sceneImage.complete) {
    sceneImage.addEventListener("load", function () {
      if (!activeYear) return;
      var cfg = isMobile() ? yearData[activeYear].mobile : yearData[activeYear].desktop;
      updateMagnifierSize(cfg);
      updateMagnifierBackground(cfg);
    });
  }

  if (isMobile()) {
    yearList.removeEventListener("scroll", onYearListScroll);

    var sceneRect = sceneWrapper.getBoundingClientRect();
    yearList.scrollTo({
      left: sceneRect.width * 0.5,
      behavior: "instant"
    });

    setTimeout(() => {
      yearList.addEventListener("scroll", onYearListScroll);
    }, 500);
  }


document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('.lottie-player').forEach(el => {
    const shouldScrollPlay = el.dataset.scroll === 'true';

    // Prepare fade-out CSS (only added once)
    if (!document.getElementById('lottie-fade-style')) {
      const style = document.createElement('style');
      style.id = 'lottie-fade-style';
      style.textContent = `
        .lottie-fade-out {
          opacity: 0;
          transition: opacity 0.8s ease;
        }
      `;
      document.head.appendChild(style);
    }

    const animation = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: false,
      autoplay: !shouldScrollPlay,
      path: el.dataset.src
    });

    // Fade out when animation finishes
    animation.addEventListener('complete', () => {
      el.classList.add('lottie-fade-out');
    });

    // Scroll-triggered logic
    if (shouldScrollPlay) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animation.play();
            observer.unobserve(el);
          }
        });
      }, {
        threshold: 0.5
      });

      observer.observe(el);
    }
  });

});

  return {
    showmore: showmore
  };
})();